module.exports = __webpack_public_path__ + "img/timing_mail.715fae6e.png";